import { Controller, useFormContext } from 'react-hook-form';
import { useRecordContext } from 'react-admin';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

type MoneyInputProps = {
  source: string;
  defaultValue?: number;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  helperText?: string | false;
  step?: string | number;
  min?: number;
};

const MoneyInput = ({
  source,
  defaultValue,
  label,
  placeholder,
  fullWidth,
  helperText,
  step = '0.01',
  min = 0,
}: MoneyInputProps) => {
  const { control } = useFormContext();
  const record = useRecordContext();
  const helper =
    helperText === false
      ? null
      : (helperText ??
        (record?.currency ? `Currency: ${record.currency}` : null));

  return (
    <Controller
      name={source}
      control={control}
      defaultValue={
        defaultValue !== undefined ? Number(defaultValue).toFixed(2) : ''
      }
      render={({ field }) => (
        <div className={cn('flex flex-col gap-1.5', fullWidth && 'w-full')}>
          {label && (
            <Label className="text-sm font-medium text-foreground">
              {label}
            </Label>
          )}
          <input
            {...field}
            type="number"
            step={step}
            min={min}
            placeholder={placeholder}
            className="h-10 w-full rounded-lg border border-border bg-secondary px-3 py-2 text-sm font-medium text-foreground placeholder:text-muted-foreground/60 transition-[border-color,box-shadow] outline-none hover:border-muted-foreground/50 focus-visible:border-muted-foreground focus-visible:ring-ring/50 focus-visible:ring-[3px] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          />
          {helper && (
            <span className="text-xs text-muted-foreground">{helper}</span>
          )}
        </div>
      )}
    />
  );
};

export default MoneyInput;
